// Messages for operator/Analytics (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.analytics.head': 'Analytics — Operator',
  'operator.analytics.title': 'Operational health',
  'operator.analytics.desc': 'Delivery health over the last 14 days, from the analytics rollups.',
  'operator.analytics.webhook_deliveries': 'Webhook deliveries',
  'operator.analytics.notification_deliveries': 'Notification deliveries',
  'operator.analytics.delivered': 'Delivered',
  'operator.analytics.failed': 'Failed',
}

export const zhTW = {
  'operator.analytics.head': '分析 — 操作員',
  'operator.analytics.title': '營運健康度',
  'operator.analytics.desc': '過去 14 天的傳送健康度，取自分析彙總。',
  'operator.analytics.webhook_deliveries': 'Webhook 傳送',
  'operator.analytics.notification_deliveries': '通知傳送',
  'operator.analytics.delivered': '已送達',
  'operator.analytics.failed': '失敗',
}
